export default "__VITE_ASSET__krKgKVv5__"